module.exports = __webpack_public_path__ + "static/media/toolbar-visible.31d00ecd.png";